import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, change, propTypes as formProps } from 'redux-form';
import { Link, browserHistory } from 'react-router';
import { ButtonV2 } from '@zola/zola-ui';
import { toastsActions } from '@zola-helpers/client';

import { updateWeddingAccount } from '../../../actions/WeddingActions';
import { updateUserStatus } from '../../../actions/UserActions';
import { RenderCheckboxRadioField } from '../../common/form';

import '../../../stylesheets/pages/settings/GuestRSVPSettingsForm.less';

// Disable  camelcase rule for file to allow for snake case elements from reducer.
/* eslint  camelcase: 0 */

class GuestRSVPSettingsForm extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateGuestRSVP = this.handleUpdateGuestRSVP.bind(this);
  }

  handleUpdateGuestRSVP(formValues) {
    const {
      account,
      showSuccessNotification,
      showErrorNotification,
      handleUpdateUserStatus,
    } = this.props;
    const successMessage = 'Your RSVP settings have been saved!';
    const errorMessage = 'There was a problem updating your settings.';
    const enable_rsvp_requests = formValues.enableGuestRSVP;
    const weddingAccountRequest = Object.assign({}, account, { enable_rsvp_requests });

    handleUpdateUserStatus().then(userStatus => {
      if (userStatus.payload.status !== 'IDLE') {
        this.props
          .onUpdateGuestRSVP(weddingAccountRequest)
          .then(showSuccessNotification(successMessage))
          .catch(() => showErrorNotification(errorMessage));
      } else {
        browserHistory.push({
          pathname: '/wedding/login',
          state: { referralPage: window.location.pathname },
        });
      }
    });
  }

  handleToggleGuestRSVP(boolString) {
    this.props.onToggleGuestRSVP(boolString);
  }

  render() {
    const { pristine, submitting, handleSubmit } = this.props;
    return (
      <form
        onSubmit={handleSubmit(this.handleUpdateGuestRSVP)}
        className="row"
        id="guest-rsvp-settings-form"
      >
        <div className="col-xs-12 col-sm-8 padding-top">
          <p>
            Do you want to let guests request access to your RSVP form on your{' '}
            <strong>wedding website</strong>?
          </p>
          <div className="subtitle">
            <span>
              Not sure what to do?{' '}
              <Link
                to="https://help.zola.com/hc/en-us/sections/115000790951-RSVP"
                target="_blank"
                rel="noopener noreferrer"
                className="zola-ui link link-arrow extra-small"
              >
                Learn More
              </Link>
            </span>
          </div>
        </div>
        <div className="col-xs-12 col-sm-4 padding-top margin-bottom">
          <Field
            value="true"
            component={RenderCheckboxRadioField}
            id="rsvp-yes"
            name="enableGuestRSVP"
            type="radio"
            label="Yes"
            inline
            checked
            styleOverride
            onChangeAction={() => this.handleToggleGuestRSVP('true')}
          />
          <Field
            value="false"
            component={RenderCheckboxRadioField}
            id="rsvp-no"
            name="enableGuestRSVP"
            type="radio"
            label="No"
            inline
            checked
            styleOverride
            onChangeAction={() => this.handleToggleGuestRSVP('false')}
          />
        </div>
        <div className="col-xs-12 padding-top">
          <ButtonV2
            type="submit"
            className="margin-top"
            disabled={pristine || submitting}
          >
            Save Guest RSVP
          </ButtonV2>
        </div>
      </form>
    );
  }
}

GuestRSVPSettingsForm.propTypes = {
  pristine: PropTypes.bool,
  onUpdateGuestRSVP: PropTypes.func,
  onToggleGuestRSVP: PropTypes.func,
  showErrorNotification: PropTypes.func,
  showSuccessNotification: PropTypes.func,
  handleUpdateUserStatus: PropTypes.func,
  ...formProps,
};

const mapStateToProps = state => {
  const { account } = state.wedding;
  let { enable_rsvp_requests } = account;
  if (!enable_rsvp_requests) {
    enable_rsvp_requests = false;
  }
  return {
    initialValues: {
      enableGuestRSVP: enable_rsvp_requests.toString(),
    },
    account: state.wedding.account,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateGuestRSVP: weddingAccountRequest => dispatch(updateWeddingAccount(weddingAccountRequest)),
  onToggleGuestRSVP: isEnabled => dispatch(change('guestRSVPSettingsForm', 'enableGuestRSVP', isEnabled)),
  showSuccessNotification: headline => dispatch(toastsActions.positive({ headline })),
  showErrorNotification: headline => dispatch(toastsActions.negative({ headline })),
  handleUpdateUserStatus: () => dispatch(updateUserStatus()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'guestRSVPSettingsForm',
    enableReinitialize: true,
  })(GuestRSVPSettingsForm)
);



// WEBPACK FOOTER //
// ./src/components/settings/privacy/GuestRSVPSettingsForm.jsx